export default __webpack_public_path__ + "5cb75ee2b8d3bbdeec9566f2160c3d2e.png";